import classNames from 'classnames';
import { string, func, bool } from 'prop-types';
import * as styles from './ProductInfo.module.scss';

const ProductInfo = ({
  productInfoTitle,
  name,
  imageUrl,
  description,
  sizeInfo,
  isReplacedProduct = false,
  onClick,
}) => {
  const onProductSelect = () => {
    onClick();
  };

  return (
    <div data-testid="product-info" className={styles.container}>
      <p>{productInfoTitle}</p>
      <div className={styles.product}>
        <div className={styles.imageContainer}>
          <button type="button" onClick={onProductSelect}>
            <img
              className={classNames({ [styles.unavailable]: isReplacedProduct })}
              src={imageUrl}
              alt={name}
            />
            {isReplacedProduct && <span>Unavailable</span>}
          </button>
        </div>
        <div className={styles.productDescription}>
          <h5>{name}</h5>
          <p>{description}</p>
          <small>{sizeInfo}</small>
        </div>
      </div>
    </div>
  );
};

ProductInfo.propTypes = {
  productInfoTitle: string.isRequired,
  name: string.isRequired,
  imageUrl: string.isRequired,
  description: string.isRequired,
  sizeInfo: string.isRequired,
  onClick: func.isRequired,
  isReplacedProduct: bool,
};

export default ProductInfo;
